import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { roomJoin } from "../store/roomSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const DeviceCheck = () => {
  // const roomName = ["A", "B", "C", "D", "E", "F"];
  const location = useLocation()
  const {name} = location?.state
  const { error } = useSelector(state => state?.room);
  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const startStream = async () => {
    try {
      const tempStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true,
      });
      tempStream.getTracks().forEach(track => track.stop()); // Stream stop karo
      handleJoinRoom();
    } catch (error) {
      toast.error("Camera and microphone permissions are required.");
      navigate("/lobby");
    }
  };

  useEffect(() => {
    startStream();
  }, []);

  const handleJoinRoom = async () => {
    try {
      await dispatch(roomJoin(id)).unwrap();
      sessionStorage.removeItem("prevRoom");
      navigate(`/room/${id}`, { state: { name }, replace: true } );
    } catch (error) {
      toast.error(error.message.slice(6));
      navigate("/lobby");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigate = () => {
    sessionStorage.removeItem("currUrlPath");
    sessionStorage.removeItem("peerId");
    navigate("/lobby", { replace: true });
  };

  if (error) {
    return (
      <div className="main-box">
        <div className="waiting-loader">
          <h5 style={{ padding: "10px 35px" }}>Error while joining room {name}</h5>
          <button className="leave-btn" onClick={handleNavigate}>Return to lobby</button>
        </div>
      </div>
    );
  }

  return (
    <>
      {loading && (
        <div className="main-box">
          <div className="waiting-loader">
            <h5 style={{ padding: "10px 35px" }}>Joining the room {name}</h5>
            <div className="loader"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeviceCheck;